<template>
  <div class="douzaiwen">
    <div class="dzwheader between">
      <sub-title text="大家都在问" />
      <div class="gd">更多></div>
    </div>
    <div class="dzwlist">
      <div class="dzwitem" v-for="item in 5" :key="item">
        <div class="toptxt flex_start">
          <div><img src="../../../assets/hotconsult/dzwicon.png" /></div>
          <div class="w245 ellipsis">离婚后探视权怎么规定的？</div>
        </div>
        <div class="bomtxt between">
          <div>类型：婚姻家庭</div>
          <div>16:09</div>
        </div>
      </div>
    </div>
    <div class="clizx">点击咨询</div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.douzaiwen {
  padding-bottom: 30px;
  .dzwheader {
    padding: 26px 0 15px;
    .gd {
      font-size: 14px;
      color: #999999;
      margin-right: 20px;
      cursor: pointer;
    }
  }
  .dzwlist {
    padding: 0 20px 0 16px;
    .dzwitem {
      padding: 20px 0;
      width: 100%;
      border-bottom: 1px solid #ccc;
      cursor: pointer;
      .toptxt {
        font-size: 14px;
        color: #333333;
        .w245 {
          width: 245px;
        }
        img {
          width: 19px;
          height: 19px;
          margin-right: 8px;
        }
      }
      .bomtxt {
        margin-top: 6px;
        font-size: 14px;
        color: #999999;
      }
      
      &:last-child {
        border-bottom: none;
      }
      &:hover{
        .toptxt{
          color: #0465ea;
        }
      }
    }
  }
  .clizx {
    cursor: pointer;
    width: 266px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    margin: 0 auto;
    background: #ffa800;
    border-radius: 3px;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>